import { createAction } from 'redux-starter-kit';

/**
 * An action that signifies vehicle diagrams should be replaced with new data.
 * @example dispatch(putVehicleDiagrams(vehicleDiagrams))
 */
export const putVehicleDiagrams = createAction('PUT_VEHICLE_DIAGRAMS');

/**
 * An action that signifies a vehicle diagram should be replaced with new data.
 * @example dispatch(putVehicleDiagram(vehicleDiagram)
 */
export const putVehicleDiagram = createAction('PUT_VEHICLE_DIAGRAM');
